import { render, staticRenderFns } from "./IndividualD.vue?vue&type=template&id=37fa98ea"
import script from "./IndividualD.vue?vue&type=script&lang=js"
export * from "./IndividualD.vue?vue&type=script&lang=js"
import style0 from "./IndividualD.vue?vue&type=style&index=0&id=37fa98ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports